
import React, { useEffect, useMemo, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'
import PlanSuggestionsRecords from './plan-suggestion'
import TreatmentRecords from './treatmentstatement-record'
import MedsDetailsRecords from './meds-details'
import { Editor } from 'react-simple-wysiwyg'

const PlanRecords = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, diagnosisName, setPatientDBdata, noteID, editNoteIndex, noteActualId }) => {


    const [lab, setLab] = useState("")
    const [planSuggestions, setPlanSuggestions] = useState([])
    const [freetype, setFreeType] = useState("")
    const [tempFreeType, setTempFreeType] = useState("")
    const [medsDetails, setMedsDetails] = useState([])
    const [hasMedsDetails, setHasMedsDetails] = useState(false)
    const [hasTreatment, setHasTreatment] = useState(false)
    const [isEditing, setIsEditing] = useState(false)



    const [patientDiagnosis, setPatientDiagnosis] = useState([])

    useEffect(() => {
        const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
        setPatientDiagnosis(patientD)
    }, [patientDBdata])

    const { getGeneralPlanStatement } = useIndexedDB()

    const [allTreamentStatements, setAllTreatmentStatements] = useState({})


    const getTreatmentPlansData = async () => {
        // let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
        // data = JSON.parse(data.d)?.Data || []
        const sturcturedTreatments = {}
        const data = await getGeneralPlanStatement()
        if (data) {

            patientDiagnosis.forEach((diagnosis) => {
                const matched = data?.length > 0 && data?.find((item) => item.Data?.diagnosis?.label === diagnosisName)
                if (matched) {
                    const suggestionNames = matched.Data.accordions.flatMap((accordion) => accordion?.suggestions?.suggestionName || []).map((s) => s.name)
                    const joinedStatements = suggestionNames?.join('\n')
                    sturcturedTreatments[diagnosis] = joinedStatements
                }
            })
            setAllTreatmentStatements(sturcturedTreatments)
        }
    }
    useEffect(() => {
        getTreatmentPlansData()
    }, [patientDiagnosis])





    const handleBlur = () => {
        setPatientDBdata((prev) => ({
            ...prev,
            currentNote: {
                ...prev.currentNote,
                data: {
                    ...prev.currentNote.data,
                    freeTypesEverything: {
                        ...prev.currentNote.data?.freeTypesEverything,
                       OrderFreeType: {
            ...prev.currentNote.data?.freeTypesEverything?.OrderFreeType,
            [diagnosisName]: tempOrderText,
          },
                    },
                },
            },

            allNotes: prev.allNotes?.map((note) => {
                if (note.id !== noteActualId) return note

                const parsedData = note.data ? JSON.parse(note.data) : {}

                return {
                    ...note,
                    data: JSON.stringify({
                        ...parsedData,
                        freeTypesEverything: {
                            ...parsedData.freeTypesEverything,
                            OrderFreeType: {
            ...prev.currentNote.data?.freeTypesEverything?.OrderFreeType,
            [diagnosisName]: tempOrderText,
          },
                        },
                    }),
                }
            }),
        }))
    }


    useEffect(() => {

        const freeType = patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.freeType || ""
        setFreeType(freeType)
        setTempFreeType(freeType)

        const lab = patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.labRemark || ""
        setLab(lab)

        const planSuggestions = patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.planSuggestion || []
        setPlanSuggestions(planSuggestions)

        const medsDetails = patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.medsDetails || []
        console.log(medsDetails, 'medsDetails')
        setMedsDetails(medsDetails)

    }, [patientDBdata])

    const [orders, setOrders] = useState({})
    const updateOrders = (updater) => {
        setOrders(prev => {
            const copy = structuredClone(prev)
            updater(copy)
            return copy
        })
    }

    console.log("order--->", orders , orders?.[diagnosisName]?.length)

    const fetchOrders = async () => {
        try {
            let parsedOrders = patientDBdata?.ordersData || []
            // let editedOrderData =  noteStructureRef?.current?.freeTypesEverything?.OrderFreeType

            const groupedOrders = {}
            parsedOrders.forEach((order) => {
                const diagnosis = order?.medication?.diagnosis
                if (!groupedOrders[diagnosis]) {
                    groupedOrders[diagnosis] = []
                }
                groupedOrders[diagnosis].push({
                    date: order?.date,
                    imaging: order.medication.imaging,
                    lab: order.medication.lab,
                    medication: order.medication.medication,
                    miscellaneous: order.medication.miscellaneous,
                    noteID: order?.medication?.noteID,
                })
            })

          console.log("groupedOrders",groupedOrders)
            setOrders(groupedOrders)

        } catch (error) {
            console.error('Failed to fetch or parse orders:', error)
        }
    }

    useEffect(() => {
        fetchOrders()
    }, [patientDBdata])

    // const renderOrder = useMemo(() => {
    //     if (!orders?.[diagnosisName]?.length) return null

    //     return (
    //         <div>
    //             <label className="form-label" style={{ marginTop: '5pt' }}>
    //                 New Orders
    //             </label>

    //             {orders[diagnosisName].map((currentOrder, index) => {

    //                 if (currentOrder?.noteID !== editNoteIndex) return null

    //                 return (
    //                     <div key={index} style={{ marginBottom: '6px' }}>
    //                         {/* Imaging */}
    //                         {currentOrder?.imaging?.imagingTypes?.length > 0 && (
    //                             <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
    //                                 <span>Imaging:</span>

    //                                 {currentOrder.imaging.imagingTypes.map((img, i) => (
    //                                     <input
    //                                         key={i}
    //                                         value={img?.type ?? ''}
    //                                         style={{
    //                                             width: '50%',
    //                                             background: '#2D2D2D',
    //                                             color: 'white',
    //                                             border: 0,
    //                                             marginBottom: '10px'
    //                                         }}
    //                                         onChange={(e) =>
    //                                             updateOrders(draft => {
    //                                                 draft[diagnosisName][index].imaging.imagingTypes[i].type =
    //                                                     e.target.value
    //                                             })
    //                                         }
    //                                     />
    //                                 ))}
    //                             </div>
    //                         )}

    //                         {/* Labs */}
    //                         {currentOrder?.lab?.labs?.length > 0 && (
    //                             <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
    //                                 <span>Labs:</span>

    //                                 {currentOrder.lab.labs.map((labItem, i) => (
    //                                     <input
    //                                         key={i}
    //                                         value={labItem.lab}
    //                                         style={{
    //                                              width: '50%',
    //                                             background: '#2D2D2D',
    //                                             color: 'white',
    //                                             border: 0,
    //                                             marginBottom: '10px'
    //                                         }}
    //                                         onChange={(e) =>
    //                                             updateOrders(draft => {
    //                                                 draft[diagnosisName][index].lab.labs[i].lab = e.target.value
    //                                             })
    //                                         }

    //                                     />
    //                                 ))}
    //                             </div>
    //                         )}


    //                         {/* Medications */}
    //                         {currentOrder?.medication?.medication?.length > 0 && (
    //                             <div style={{ display: 'flex', gap: '6px', marginBottom: 4 }}> 
    //                                 <span>Medications:</span>
    //                                 <div>

    //                                 {currentOrder.medication.medication.map((med, i) => (
    //                                     <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: 4 }}>
    //                                         <input
    //                                             placeholder="Name"
    //                                             value={med.name}
    //                                             style={{
    //                                                 // width: '100%',
    //                                                 background: '#2D2D2D',
    //                                                 color: 'white',
    //                                                 border: 0,
    //                                             }}
    //                                             onChange={(e) =>
    //                                                 updateOrders(draft => {
    //                                                     draft[diagnosisName][index].medication.medication[i].name =
    //                                                         e.target.value
    //                                                 })
    //                                             }
    //                                         />

    //                                         <input
    //                                             placeholder="Dosage"
    //                                             value={med.dosage}
    //                                             style={{
    //                                                 // width: '100%',
    //                                                 background: '#2D2D2D',
    //                                                 color: 'white',
    //                                                 border: 0,
    //                                             }}
    //                                             onChange={(e) =>
    //                                                 updateOrders(draft => {
    //                                                     draft[diagnosisName][index].medication.medication[i].dosage =
    //                                                         e.target.value
    //                                                 })
    //                                             }
    //                                         />

    //                                         <input
    //                                             placeholder="Frequency"
    //                                             value={med.frequency}
    //                                             style={{
    //                                                 // width: '100%',
    //                                                 background: '#2D2D2D',
    //                                                 color: 'white',
    //                                                 border: 0,
    //                                             }}
    //                                             onChange={(e) =>
    //                                                 updateOrders(draft => {
    //                                                     draft[diagnosisName][index].medication.medication[i].frequency =
    //                                                         e.target.value
    //                                                 })
    //                                             }
    //                                         />
    //                                     </div>
    //                                 ))}
    //                                 </div>
    //                             </div>
    //                         )}


    //                         {/* Miscellaneous */}
    //                         {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
    //                             <div>
    //                                 {currentOrder.miscellaneous.miscellaneous.map((misc, i) => (
    //                                     <textarea
    //                                         key={i}
    //                                         value={misc}
    //                                         onChange={(e) =>
    //                                             updateOrders(draft => {
    //                                                 draft[diagnosisName][index].miscellaneous.miscellaneous[i] =
    //                                                     e.target.value
    //                                             })
    //                                         }
    //                                     />
    //                                 ))}
    //                             </div>
    //                         )}

    //                     </div>
    //                 )
    //             })}
    //         </div>
    //     )
    // }, [orders, diagnosisName, editNoteIndex])

    const renderOrder = useMemo(() => {
        if (!orders?.[diagnosisName]?.length) return null

        return (
            <div>
                <h5> New Orders</h5>

                {orders[diagnosisName].map((currentOrder, index) => {

                    if (currentOrder?.noteID !== editNoteIndex) return null

                    return (
                        <div key={index} style={{ marginBottom: '6px' }}>
                            {/* Imaging */}
                            {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    <span>Imaging:</span>
                                    {currentOrder.imaging.imagingTypes.map((img, i) => (
                                        <span style={{ maxWidth: "max-content", whiteSpace: "nowrap" }} key={i}>
                                            {typeof img?.type === 'object'
                                                ? JSON.stringify(img.type)
                                                : img?.type}
                                            ,
                                        </span>
                                    ))}
                                </div>
                            )}

                            {/* Labs */}
                            {currentOrder?.lab?.labs?.length > 0 && (
                                <div style={{ display: 'flex', gap: '4pt' }}>
                                    <span>Labs:</span>
                                    {currentOrder.lab.labs.map((labItem, i) => (
                                        <span key={i}>
                                            {labItem?.lab}
                                            {labItem?.reason ? ` - Reason for ${labItem.reason}` : ''},
                                        </span>
                                    ))}
                                </div>
                            )}

                            {/* Medications */}
                            {currentOrder?.medication?.medication?.length > 0 && (
                                <div style={{ display: 'flex', gap: '4pt' }}>
                                    <span>Medications:</span>
                                    {currentOrder.medication.medication.map((med, i) => (
                                        <span key={i}>
                                            {med?.name} {med?.dosage} {med?.route}
                                            {med?.frequency ? ` ${med.frequency}` : ''}
                                            {med?.reason ? ` - ${med.reason}` : ''},
                                        </span>
                                    ))}
                                </div>
                            )}

                            {/* Miscellaneous */}
                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                <div>
                                    {currentOrder.miscellaneous.miscellaneous.map((misc, i) => (
                                        <div key={i}>Miscellaneous: {misc}</div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }, [orders])


    // const ordersToText = (orders, diagnosisName, editNoteIndex) => {
    //     if (!orders?.[diagnosisName]?.length) return ''
    //      console.log("orders Data", orders)
    //     let output = '\nNew Orders\n'

    //     orders[diagnosisName].forEach((currentOrder) => {
    //         if (currentOrder?.noteID !== editNoteIndex) return

    //         // Imaging
    //         if (currentOrder?.imaging?.imagingTypes?.length) {
    //             output += '\nImaging:\n'
    //             currentOrder.imaging.imagingTypes.forEach((img) => {
    //                 const type =
    //                     typeof img?.type === 'object'
    //                         ? JSON.stringify(img.type)
    //                         : img?.type

    //                 output += `- ${type}\n`
    //             })
    //         }

    //         // Labs
    //         if (currentOrder?.lab?.labs?.length) {
    //             output += '\nLabs:\n'
    //             currentOrder.lab.labs.forEach((lab) => {
    //                 output += `- ${lab.lab}`
    //                 if (lab?.reason) output += ` (Reason: ${lab.reason})`
    //                 output += '\n'
    //             })
    //         }

    //         // Medications
    //         if (currentOrder?.medication?.medication?.length) {
    //             output += '\nMedications:\n'
    //             currentOrder.medication.medication.forEach((med) => {
    //                 output += `- ${med.name} ${med.dosage ?? ''} ${med.route ?? ''}`
    //                 if (med?.frequency) output += ` ${med.frequency}`
    //                 if (med?.reason) output += ` — ${med.reason}`
    //                 output += '\n'
    //             })
    //         }

    //         // Miscellaneous
    //         if (currentOrder?.miscellaneous?.miscellaneous?.length) {
    //             output += '\nMiscellaneous:\n'
    //             currentOrder.miscellaneous.miscellaneous.forEach((misc) => {
    //                 output += `- ${misc}\n`
    //             })
    //         }
    //     })

    //     return output.trim()
    // }
    const ordersToText = (orders, diagnosisName, editNoteIndex) => {
  if (!orders?.[diagnosisName]?.length) return ''

  let output = 'New Orders\n'


  orders[diagnosisName].forEach((currentOrder) => {
    if (currentOrder?.noteID !== editNoteIndex) return

    // Imaging
    if (currentOrder?.imaging?.imagingTypes?.length) {
      const imagingText = currentOrder.imaging.imagingTypes
        .map((img) =>
          typeof img?.type === 'object'
            ? JSON.stringify(img.type)
            : img?.type
        )
        .join(', ')

      output += `Imaging: ${imagingText},\n`
    }

    // Labs
    if (currentOrder?.lab?.labs?.length) {
      const labsText = currentOrder.lab.labs
        .map((lab) =>
          `${lab.lab}${lab?.reason ? ` - ${lab.reason}` : ''}`
        )
        .join(', ')

      output += `Labs: ${labsText},\n`
    }

    // Medications
    if (currentOrder?.medication?.medication?.length) {
      const medsText = currentOrder.medication.medication
        .map((med) =>
          `${med.name} ${med.dosage ?? ''} ${med.route ?? ''}${
            med?.frequency ? ` ${med.frequency}` : ''
          }${med?.reason ? ` - ${med.reason}` : ''}`.trim()
        )
        .join(', ')

      output += `Medications: ${medsText},\n`
    }

    // Miscellaneous
    if (currentOrder?.miscellaneous?.miscellaneous?.length) {
      const miscText = currentOrder.miscellaneous.miscellaneous.join(', ')
      output += `Miscellaneous: ${miscText}\n`
    }
  })

  return output.trim()
}



    const orderText = useMemo(() => {
        return ordersToText(orders, diagnosisName, editNoteIndex)
    }, [orders, diagnosisName, editNoteIndex])


    console.log("orderText",orderText)
    const [tempOrderText, setTempOrderText] = useState('')

    useEffect(() => {
        const handleOrderText = () => {
            console.log("orderText",orderText,patientDBdata?.currentNote?.data?.freeTypesEverything?.OrderFreeType?.[diagnosisName])
             patientDBdata?.currentNote?.data?.freeTypesEverything?.OrderFreeType?.[diagnosisName] ?  setTempOrderText(patientDBdata?.currentNote?.data?.freeTypesEverything?.OrderFreeType?.[diagnosisName]) :
        setTempOrderText(orderText)
        }
        handleOrderText()
    }, [orderText])



    const handleFreeTypeBlur = () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        plans: {
                            ...prev?.currentNote?.data?.plans,
                            [diagnosisName]: {
                                ...prev?.currentNote?.data?.plans?.[diagnosisName],
                                freeType: tempFreeType,
                            },
                        },
                    },
                },
                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteID) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}
                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                plans: {
                                    ...parsedData?.plans,
                                    [diagnosisName]: {
                                        ...parsedData?.plans?.[diagnosisName],
                                        freeType: tempFreeType,
                                    },
                                },
                            }),
                        }
                    }
                    return note
                })
            }
        })
    }
    console.log("reder only OERder",)
    if (!renderOrder && !medsDetails?.length && !freetype && !lab && !planSuggestions && !allTreamentStatements?.[diagnosisName]) return null
    console.log("renderOrderData", renderOrder, medsDetails?.length, freetype, lab, planSuggestions, allTreamentStatements?.[diagnosisName])
    return (
        <div className='w-100'>
            {(freetype || renderOrder || hasMedsDetails || hasTreatment) && <p>Plans</p>}
            {/* Freetype */}
            <div>
                {freetype && <GraytextareaAdjustable
                    onBlur={handleFreeTypeBlur}
                    value={tempFreeType}
                    onChange={(e) => setTempFreeType(e.target.value)}
                    label="Free Type"
                />}
            </div>

            <PlanSuggestionsRecords diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />



            {/* <div>{renderOrder}</div> */}
           

            {tempOrderText && orders?.[diagnosisName]?.length && (
                <GraytextareaAdjustable
                    style={{
                         fontSize: '14px'
                    }}
                    label="Orders"
                    value={tempOrderText}
                    onChange={(e) => setTempOrderText(e.target.value)}
                    onBlur={handleBlur}
                />
            )}


            <MedsDetailsRecords patientDiagnosis={patientDiagnosis} diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} hasMedsDetails={hasMedsDetails} setHasMedsDetails={setHasMedsDetails} />

            <TreatmentRecords patientDiagnosis={patientDiagnosis} diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} hasTreatment={hasTreatment} setHasTreatment={setHasTreatment} />


        </div>
    )
}


export default PlanRecords